import React from 'react';
import { Link } from 'react-router-dom';
import config from '../utils/config';

function TermsOfService() {
  const lastUpdated = new Date('2026-01-08').toLocaleDateString();

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#0a0b0d', 
      color: '#e4e4e7',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none',
              marginBottom: '16px',
              display: 'inline-block'
            }}
          >
            ← Back to Home
          </Link>
          
          <h1 style={{ 
            fontSize: '32px', 
            fontWeight: 'bold', 
            marginBottom: '8px',
            color: '#ffffff'
          }}>
            Terms of Service
          </h1>
          
          <p style={{ color: '#9ca3af', fontSize: '14px' }}>
            Last updated: {lastUpdated}
          </p>
        </div>

        {/* Content */}
        <div style={{ 
          backgroundColor: '#12141a', 
          border: '1px solid #1f232e',
          borderRadius: '8px',
          padding: '32px',
          lineHeight: '1.6'
        }}>
          
          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            1. Acceptance of Terms
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            By accessing and using this file sharing service ("Service"), you accept and agree to be bound by the terms and provision of this agreement. 
            If you do not agree to abide by the above, please do not use this Service.
          </p>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            2. Description of Service
          </h2>
          
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            Our Service provides users with the ability to:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Upload files up to 10GB each</li>
            <li>Share files via secure links</li>
            <li>Set expiry periods for automatic file deletion (1, 3, 5, or 7 days)</li>
            <li>Access files from any device with the share link</li>
            <li>Preview certain file types in the browser</li>
          </ul>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            3. User Responsibilities
          </h2>
          
          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Acceptable Use
          </h3>
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            You agree to use the Service only for lawful purposes and in accordance with these Terms. You agree not to:
          </p>
          <ul style={{ marginBottom: '16px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Upload illegal, harmful, threatening, abusive, defamatory, or obscene content</li>
            <li>Upload copyrighted material</li>
            <li>Upload malware, viruses, or any malicious code</li>
            <li>Use the Service to spam or distribute unsolicited communications</li>
            <li>Attempt to circumvent any security measures or access restrictions</li>
            <li>Use automated tools to access the Service beyond reasonable personal use</li>
            <li>Share content that violates any applicable laws or regulations</li>
          </ul>

          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Content Responsibility
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>You are solely responsible for all content you upload</li>
            <li>You must have the legal right to upload and share any content</li>
            <li>You retain ownership of your content, but grant us rights to store and serve it</li>
            <li>You must comply with all applicable laws regarding your content</li>
          </ul>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            4. Service Limitations
          </h2>
          
          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            File Restrictions
          </h3>
          <ul style={{ marginBottom: '16px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Maximum file size: 10GB per file</li>
            <li>File expiry: All files are automatically deleted after the chosen expiry period (1, 3, 5, or 7 days)</li>
            <li>Maximum storage: 10GB total per user</li>
          </ul>

          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Service Availability
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Service availability is not guaranteed and may be interrupted</li>
            <li>We may perform maintenance that temporarily affects access</li>
            <li>We reserve the right to modify or discontinue the Service</li>
            <li>No guarantee of data persistence beyond the expiry period</li>
          </ul>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            5. Privacy and Data
          </h2>
          
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices.
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>No personal information is required to use the Service</li>
            <li>Files are encrypted in transit and at rest</li>
            <li>We may collect anonymous usage statistics</li>
            <li>Files are automatically deleted after the expiry period</li>
          </ul>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            6. Intellectual Property
          </h2>
          
          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Your Content
          </h3>
          <ul style={{ marginBottom: '16px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>You retain all rights to content you upload</li>
            <li>You grant us a limited license to store, process, and serve your content</li>
            <li>This license terminates when your files are deleted</li>
          </ul>

          <h3 style={{ color: '#e2e8f0', marginBottom: '12px', fontSize: '16px', fontWeight: '500' }}>
            Our Service
          </h3>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>The Service and its technology are protected by copyright and other laws</li>
            <li>You may not copy, modify, or reverse engineer any part of the Service</li>
            <li>All trademarks and service marks are the property of their respective owners</li>
          </ul>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            7. Disclaimer of Warranties
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            <strong>THE SERVICE IS PROVIDED "AS IS" WITHOUT ANY WARRANTIES OF ANY KIND.</strong> We expressly disclaim all warranties, 
            whether express, implied, or statutory, including but not limited to implied warranties of merchantability, 
            fitness for a particular purpose, and non-infringement.
          </p>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            8. Limitation of Liability
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            <strong>IN NO EVENT SHALL WE BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES</strong>, 
            including but not limited to loss of profits, data, use, or other intangible losses, resulting from your use of the Service, 
            even if we have been advised of the possibility of such damages.
          </p>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            9. Content Removal
          </h2>
          
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            We reserve the right to remove any content that:
          </p>
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Violates these Terms of Service</li>
            <li>Is illegal or harmful</li>
            <li>Infringes on intellectual property rights</li>
            <li>Is reported as abusive or inappropriate</li>
            <li>Consumes excessive system resources</li>
          </ul>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            10. Termination
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            We may terminate or suspend your access to the Service immediately, without prior notice or liability, 
            for any reason whatsoever, including without limitation if you breach the Terms. 
            Upon termination, your right to use the Service will cease immediately.
          </p>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            11. Changes to Terms
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
            If a revision is material, we will try to provide at least 30 days notice prior to any new terms taking effect.
          </p>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            12. Governing Law
          </h2>
          
          <p style={{ marginBottom: '24px', color: '#d1d5db' }}>
            These Terms shall be interpreted and governed by the laws of India, without regard to conflict of law provisions. 
            Any legal action or proceeding shall be brought exclusively in the courts of India.
          </p>

          <h2 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '20px', fontWeight: '600' }}>
            13. Contact Information
          </h2>
          
          <p style={{ marginBottom: '16px', color: '#d1d5db' }}>
            If you have any questions about these Terms of Service, please <Link to="/contact" style={{ color: '#ffffff', textDecoration: 'none' }}>contact us</Link>:
          </p>
          
          <ul style={{ marginBottom: '24px', paddingLeft: '20px', color: '#d1d5db' }}>
            <li>Email: {config.contactEmail}</li>
            <li>
              Through our website <Link to="/contact" style={{ color: '#ffffff', textDecoration: 'none' }}>contact form</Link>
            </li>
          </ul>

          {/* Legal notice removed per request */}
        </div>

        {/* Footer Navigation */}
        <div className="mt-8 text-center">
          <Link 
            to="/privacy-policy"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none',
              marginRight: '24px'
            }}
          >
            Privacy Policy
          </Link>
          <Link 
            to="/contact"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none',
              marginRight: '24px'
            }}
          >
            Contact
          </Link>
          
          <Link 
            to="/"
            style={{
              color: '#9ca3af',
              fontSize: '14px',
              textDecoration: 'none'
            }}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService; 